import React from 'react';
import { useCustomStyles } from '../../../../modules/providers/StylesProvider';
import {
  Button,
  Checkbox,
  Container,
  ContainerCheckbox,
  Content,
  CredihomeText,
  Description,
  DeveloperBy,
  Footer,
  FormField,
  InputField,
  Label,
  LabelCheckbox,
  Logo,
  Title,
} from './Preview.styles';

export function Preview(): JSX.Element {
  const { styles } = useCustomStyles();

  return (
    <Container backgroundColor={styles.backgroundColor}>
      <Content>
        <Logo src={styles.file} />

        <Title>Simule agora seu créditto</Title>
        <Description>
          Simule seu financiamento em minutos com todos os bancos e consiga a melhor proposta!
        </Description>

        <FormField>
          <Label>Produto</Label>
          <InputField />

          <Label>Valor do imóvel</Label>
          <InputField />

          <Label>Valor da entrada</Label>
          <InputField />

          <Label>Qual o objetivo da simulação?</Label>

          <ContainerCheckbox>
            <Checkbox />
            <LabelCheckbox>Apenas conhecer os valores</LabelCheckbox>
          </ContainerCheckbox>

          <ContainerCheckbox>
            <Checkbox />
            <LabelCheckbox>Ter uma proposta dos bancos</LabelCheckbox>
          </ContainerCheckbox>

          <Button backgroundColor={styles.primaryColor}>Continuar</Button>
        </FormField>

        {!styles.hideLogo && (
          <Footer>
            <DeveloperBy>Desenvolvido por</DeveloperBy>
            <CredihomeText>CREDIHOME</CredihomeText>
          </Footer>
        )}
      </Content>
    </Container>
  );
}
